var exports = {
  "default": "x31de4314--72ae32--default",
  "light": "x31de4314--72ae32--light",
  "outline": "x31de4314--72ae32--outline",
};

module.exports = exports;
